<template>
  <!-- <v-card
    color="transparent"
    elevation="0"
    class="all-trade-tab rounded-0"
  >
    <v-tabs
      background-color="transparent"
      v-model="model"
    >
      <v-tab class="ml-0" :href="`#tab-1`"> Send Email </v-tab>
      <v-tab :href="`#tab-2`"> View Templates </v-tab>
      <v-tabs-items v-model="model">
        <v-tab-item :value="`tab-1`">
          <SendEmailTab></SendEmailTab>
        </v-tab-item>
        <v-tab-item :value="`tab-2`">
          <ViewTemplatesTab></ViewTemplatesTab>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </v-card> -->
  <SendEmailTab></SendEmailTab>
</template>

<script>
import SendEmailTab from "./SendEmailTab.vue";
import ViewTemplatesTab from "./ViewTemplatesTab.vue";
export default {
  // data() {
  //   return {
  //     tab: null,
  //     model: "tab-1",
  //   };
  // },
  components: {
    SendEmailTab,
    // ViewTemplatesTab,
  },
};
</script>
